export const sessionAttendance = {
    namespaced: true,

    state: {
        participants: [],
        selectedParticipants: [],
        selectedCrews: [],
        selectedSquads: [],
        selectedStatus: []
    },

    getters: {
        participants(state) {
            return _.sortBy(state.participants, 'user.data.full_name');
        },

        selectedParticipants(state) {
            return _.sortBy(state.selectedParticipants, 'user.data.full_name');
        },

        selectedCrews(state) {
            return _.sortBy(state.selectedCrews, 'name');
        },

        selectedSquads(state) {
            return _.sortBy(state.selectedSquads, 'name');
        },

        selectedStatus(state) {
            return _.sortBy(state.selectedStatus, 'name');
        }
    },

    mutations: {
        setParticipants(state, data) {
            state.participants = data;
        },

        setSelectedParticipants(state, data) {
            state.selectedParticipants = data;
        },

        setSelectedCrews(state, data) {
            state.selectedCrews = data;
        },

        setSelectedSquads(state, data) {
            state.selectedSquads = data;
        },

        setSelectedStatus(state, data) {
            state.selectedStatus = data;
        }
    }
};

export default sessionAttendance;
